<div class="flex justify-end">

    <button *ngIf="!readOnly" [disabled]="!configureSession" color="primary" class="block" mat-raised-button
        (click)="openSessionPopup()">
        Manage
    </button>
</div>

<table>
    <thead>
        <tr>
            <th>
                Field
            </th>
            <th>
                Current Value
            </th>

            <th>
                Desired Value
            </th>

            <th>
                Status
            </th>
        </tr>
    </thead>

    <tr>
        <td>
            Session
        </td>

        <td>
            <!-- sign in frequency  -->
            <ul>


                <li class="mb-2" *ngIf="policy?.sessionControls?.cloudAppSecurity?.isEnabled">
                    <div class="!font-bold">
                        Use Conditional Access App Control
                    </div>

                    <div class="pl-3">


                        <span>{{cloudAppSecurity[policy?.sessionControls?.cloudAppSecurity?.cloudAppSecurityType]}}</span>
                    </div>
                </li>




                <li class="mb-2" *ngIf="policy?.sessionControls?.signInFrequency?.isEnabled">
                    <div class="!font-bold">
                        Sign-in frequency
                    </div>


                    <div class="pl-3">
                        <p *ngIf="policy?.sessionControls?.signInFrequency?.frequencyInterval === 'everyTime'">
                            Every time
                        </p>


                        <p *ngIf="policy?.sessionControls?.signInFrequency?.frequencyInterval === 'timeBased'">
                            Periodic reauthentication every <span> {{policy?.sessionControls?.signInFrequency?.value}}
                                {{policy?.sessionControls?.signInFrequency?.type}}</span>
                        </p>
                    </div>
                </li>

                <li class="mb-2" *ngIf="policy?.sessionControls?.persistentBrowser?.isEnabled">
                    <div class="!font-bold">
                        Persistent browser session
                    </div>

                    <div *ngIf="policy?.sessionControls?.persistentBrowser?.mode === 'always'" class="pl-3">
                        <span>Always persistent</span>
                    </div>


                    <div *ngIf="policy?.sessionControls?.persistentBrowser?.mode === 'never'" class="pl-3">
                        <span>Never persistent</span>
                    </div>
                </li>

                <li class="mb-2" *ngIf="policy?.sessionControls?.disableResilienceDefaults">
                    <div class="!font-bold">
                        Disable resilience defaults
                    </div>
                </li>




                <li class="mb-2" *ngIf="policy?.sessionControls?.continuousAccessEvaluation">

                    <div class="!font-bold">
                        Customize continuous access evaluation
                    </div>


                    <div class="pl-3">
                        <span>{{continuousAccessEvaluation[policy?.sessionControls?.continuousAccessEvaluation?.mode]}}</span>
                    </div>
                </li>
            </ul>

        </td>

        <!-- desired value  -->
        <td>
            <ul>
                <li class="mb-2" *ngIf="sessionControllerValue.cloudAppSecurity?.isEnabled">
                    <div class="!font-bold">
                        Use Conditional Access App Control
                    </div>

                    <div class="pl-3">
                        <span>{{cloudAppSecurity[sessionControllerValue.cloudAppSecurity?.cloudAppSecurityType]}}</span>
                    </div>
                </li>

                <li class="mb-2" *ngIf="sessionControllerValue.signInFrequency?.isEnabled">
                    <div class="!font-bold">
                        Sign-in frequency
                    </div>


                    <div class="pl-3">
                        <p *ngIf="sessionControllerValue.signInFrequency?.frequencyInterval === 'everyTime'">
                            Every time
                        </p>


                        <p *ngIf="sessionControllerValue.signInFrequency?.frequencyInterval === 'timeBased'">
                            Periodic reauthentication every <span> {{sessionControllerValue.signInFrequency?.value}}
                                {{sessionControllerValue.signInFrequency?.type}}</span>
                        </p>
                    </div>

                </li>

                <li class="mb-2" *ngIf="sessionControllerValue.persistentBrowser?.isEnabled">
                    <div class="!font-bold">
                        Persistent browser session
                    </div>

                    <div *ngIf="sessionControllerValue.persistentBrowser?.mode === 'always'" class="pl-3">
                        <span>Always persistent</span>
                    </div>


                    <div *ngIf="sessionControllerValue.persistentBrowser?.mode === 'never'" class="pl-3">
                        <span>Never persistent</span>
                    </div>
                </li>

                <li class="mb-2" *ngIf="sessionControllerValue.disableResilienceDefaults">
                    <div class="!font-bold">
                        Disable resilience defaults
                    </div>
                </li>


                <li class="mb-2" *ngIf="sessionControllerValue.continuousAccessEvaluation?.mode">

                    <div class="!font-bold">
                        Customize continuous access evaluation
                    </div>


                    <div class="pl-3">
                        <span>{{continuousAccessEvaluation[sessionControllerValue.continuousAccessEvaluation?.mode]}}</span>
                    </div>
                </li>




            </ul>
        </td>

        <td>
            <sway-baseline-status *ngIf="policy?.id" [hasError]="errorsString?.includes('session') ">
            </sway-baseline-status>


            <mat-icon *ngIf="!policy?.id" class="warn-icon"
                matTooltip="Baseline is not associated with any policy">warning</mat-icon>

        </td>
    </tr>
</table>
